import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { dAPI } from 'appSrc/api';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import EditQRCodeModal from 'appSrc/AdminPanel/pages/Modals/QRCode/EditQRCodeModal';
import { ExternalLink, PrimaryButton, DLRichTextOutput } from 'appSrc/components/UI';
import ListCoverImage from 'appSrc/components/List/CoverImage';
import { encodeForURI } from 'appSrc/utils';
import { tdcDomainMatch } from 'appSrc/utils/random';
import style from './styles/style.module.css';

class IndividualQRCodePage extends Component {
    state = {
        fetching: true,
        qrCode: {},
        editing: false,
    }

    componentDidMount() {
        this.loadQRCode( this.props.match.params.qrid );
    }

    componentDidUpdate( prevProps ) {
        if( this.props.match.params.qrid !== prevProps.match.params.qrid ) {
            this.setState( { fetching: true } );
            this.loadQRCode( this.props.match.params.qrid );
        }
    }

    loadQRCode = ( id ) => {
        this.props.getQRCode( id )
        .then( ( qrCode ) => {
            this.setState( {
                fetching: false,
                qrCode: qrCode,
            } );
        } )
        .catch( () => {
            this.props.redirect( '/admin/qr_codes/' );
        } );
    }

    openEditModal = () => {
        this.setState( { editing: true } );
    }

    onEditSubmit = ( qrCode ) => {
        if( qrCode == null ) {
            this.props.redirect( '/admin/qr_codes/' );
        } else {
            this.setState( { qrCode: { ...qrCode }, editing: false } );
        }
    }

    onEditClose = () => {
        this.setState( { editing: false } );
    }


    render() {
        const { fetching, qrCode } = this.state;

        if( fetching ) {
            return (
                <section className={ style.individual }>
                    <LoadingReplace />
                </section>
            );
        }

        return (
            <section className={ style.individual }>
                <div className={ style.head }>
                    <div className={ style.controls }>
                        <div className={ style.backLink } onClick={ this.props.history.goBack }>Back</div>
                        <div>
                            <PrimaryButton label='Edit QR Code Data' onClick={ this.openEditModal } style={ { width: '200px', marginRight: '15px' } } />
                            {/* <ExternalLink target='_blank' to={ `${ tdcDomainMatch() }/brands/${ brand.id }/${ encodeForURI(brand.name) }` }>
                                <PrimaryButton reverse label='Public View' />
                            </ExternalLink> */}
                        </div>
                    </div>
                    <div className={ style.individualDetails }>
                        <div>
                            <ListCoverImage coverImage={ qrCode.qr_image } />
                        </div>
                        <div>
                            <div className={ style.title }>
                                <h2 style={ { marginRight: '15px' } }>{ qrCode.name }</h2>
                            </div>
                            <div className={ style.description }>
                                <DLRichTextOutput content={ qrCode.description } />
                            </div>
                        </div>
                    </div>
                    {/* <div className={ style.tabs }>
                        <div className={ style.tabOption }
                        onClick={ () => { this.setState( { tab: 'products' } ); } }
                        data-active={ this.state.tab == 'products' }>
                            Products ({ products.length })
                        </div>
                    </div> */}
                </div>
                { this.state.editing &&
                    <EditQRCodeModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    qrCode={ qrCode } />
                }
                
            </section>
        );
    }
}

const mapDispatchToProps = ( dispatch ) => {
    return {
        getQRCode: ( id ) => {
            return dAPI.get( `/admin/qr_codes/${ id }` );
        },
        updateQR: ( id, data ) => {
            return dAPI.patch( `/admin/qr_codes/${ id }`, data );
        },
        getQRCodes: ( id ) => {
            return dAPI.get( '/admin/qr_codes/' );
        },
        redirect: ( url ) => {
            dispatch( push( url ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( IndividualQRCodePage );
